import turn14StoresDefaults from '../bigcommerce-turn14-stores/config.js';

export default {
  includes: ['bigcommerce-turn14-stores'],
  ...turn14StoresDefaults,
};
